import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  inject,
  makeEnvironmentProviders,
  provideEnvironmentInitializer,
} from '@angular/core';

import {
  ASI_STATS_SENDER_FETCH_IMPL,
  ASI_STATS_SENDER_FETCH_URL,
} from '@cosmos/analytics/asi-stats';
import { injectConfigProperty } from '@cosmos/config';
import { LocalStorageService } from '@cosmos/data-access-storage';
import { CosFeatureFlagsToolbarControlsSet } from '@cosmos/feature-flags-toolbar';

import { provideStatsCollectorStorage } from './feature-stats-collector-storage.service';
import { StatsCollectorInterceptor } from './feature-stats-collector.interceptor';
import { FeatureStatsCollectorService } from './feature-stats-collector.service';

export function withStatsDebugging() {
  return makeEnvironmentProviders([
    {
      provide: ASI_STATS_SENDER_FETCH_URL,
      useFactory: () => {
        // Check if stats debugging is enabled via localStorage flag
        const localStorageService = inject(LocalStorageService);
        const debugEnabled = !!localStorageService.getItem<boolean>(
          'enableStatsDebugging'
        );

        const config = injectConfigProperty('asiStats');

        if (!debugEnabled) {
          return config.url;
        }

        // Append debug query params to force publishing and enable debug mode on the stats endpoint
        const debugParams = new URLSearchParams({
          debug: 'true',
          forcePublish: 'true',
        });

        return `${config.url}?${debugParams.toString()}`;
      },
    },

    {
      provide: ASI_STATS_SENDER_FETCH_IMPL,
      useFactory: () => {
        const service = inject(FeatureStatsCollectorService);
        // `service.fetch.bind(service)` was slower.
        return (requestUrl: string, init: RequestInit) =>
          service.fetch(requestUrl, init);
      },
    },

    provideEnvironmentInitializer(() => {
      const controls = inject(CosFeatureFlagsToolbarControlsSet);
      controls.add(async () => {
        const { CosFeatureStatsDebuggingComponent } = await import(
          './feature-stats-debugging.component'
        );
        return CosFeatureStatsDebuggingComponent;
      });
    }),
    {
      provide: HTTP_INTERCEPTORS,
      multi: true,
      useClass: StatsCollectorInterceptor,
    },
    provideStatsCollectorStorage(LocalStorageService),
  ]);
}
